<template>
  <div>
    <img class="imgs" src="../../assets/resellerSummerEvent.jpg" alt="">
  </div>
</template>
<script>
export default {
  name: "App",
  components: {
  },
  data() {
    return {
    };
  },
  created() {
    document.title = 'حدث وكلاء الشحن الصيفي'
  },
  mounted() {
  },
  methods: {
  },
};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>